export const GET_THREAD_REQUEST = 'GET_THREAD_REQUEST';
export const GET_THREAD_DATA = 'GET_THREAD_DATA';
export const GET_THREAD_ERROR = 'GET_THREAD_ERROR';

export const CREATE_THREAD_REQUEST = 'CREATE_THREAD_REQUEST';
export const CREATE_THREAD_DATA = 'CREATE_THREAD_DATA';
export const CREATE_THREAD_ERROR = 'CREATE_THREAD_ERROR';

export const UPDATE_THREAD_REQUEST = 'UPDATE_THREAD_REQUEST';
export const UPDATE_THREAD_DATA = 'UPDATE_THREAD_DATA';
export const UPDATE_THREAD_ERROR = 'UPDATE_THREAD_ERROR';

export const DELETE_THREAD_REQUEST = 'DELETE_THREAD_REQUEST';
export const DELETE_THREAD_DATA = 'DELETE_THREAD_DATA';
export const DELETE_THREAD_ERROR = 'DELETE_THREAD_ERROR';
